import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=cd7c154e&scoped=true&lang=pug&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=cd7c154e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7c154e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd7c154e')) {
      api.createRecord('cd7c154e', component.options)
    } else {
      api.reload('cd7c154e', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=cd7c154e&scoped=true&lang=pug&", function () {
      api.rerender('cd7c154e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductForm.vue"
export default component.exports